import React from "react";
import PropTypes from "prop-types";

const PlayButtonIcon = ({ color = "#1DCDA3", size = 20 }) => (
  <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <rect width={size} height={size} rx="4" />
      <path
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
        d="M5 3.5 16 10 5 16.5z"
      />
    </g>
  </svg>
);

PlayButtonIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default PlayButtonIcon;
